module.exports = "/images/resource-image-move.png?ebc4e8abbb38efddd46e12709230fdee";